// extracted by mini-css-extract-plugin
export default {"main":"layout_main__GdxiJ","footer":"layout_footer__HPy+U"};